import classnames from "classnames";

import {percentage, shortCurrency} from "@/lib/format.tsx";
import {Discount} from "@/lib/types/billing.ts";
export interface DiscountsProps {
  discounts: Discount[];
}

export const Discounts = ({discounts}: DiscountsProps) => {
  return (
    <>
      {discounts.map((el, idx) => {
        if (!(el.value * 1.0)) {
          return false;
        }
        return (
          <div
            className={classnames("row my-3 discount-row", {"pulse-color-green-500 fw-bold": el.highlight})}
            key={"discount-" + idx}
          >
            <div className="col-8">
              {el.percent > 0 ? `${percentage(el.percent, 0)} ` : ""}
              {el.title}
            </div>
            <div className="col-4 text-end">
              <strong className="pulse-color-green-500 fw-bold">{shortCurrency(el.value * -1, 2)}</strong>
            </div>
          </div>
        );
      })}
    </>
  );
};
